import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-seq-new-arrow",
  "use": "icon-seq-new-arrow-usage",
  "viewBox": "0 0 15 11",
  "content": "<symbol viewBox=\"0 0 15 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-seq-new-arrow\">\n<path d=\"M12.25 3L7.25 8L2.25 3\" stroke=\"#475467\" stroke-width=\"1.4\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol